import { render, staticRenderFns } from "./ServiceAd.vue?vue&type=template&id=396e51b8&scoped=true&"
import script from "./ServiceAd.vue?vue&type=script&lang=js&"
export * from "./ServiceAd.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAd.vue?vue&type=style&index=0&id=396e51b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e51b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396e51b8')) {
      api.createRecord('396e51b8', component.options)
    } else {
      api.reload('396e51b8', component.options)
    }
    module.hot.accept("./ServiceAd.vue?vue&type=template&id=396e51b8&scoped=true&", function () {
      api.rerender('396e51b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServiceAd.vue"
export default component.exports